import { Component, OnInit, Input } from '@angular/core'
import { DateFormatService, LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-event-information',
  templateUrl: './event-information.component.html'
})
export class EventInformationComponent implements OnInit {

  @Input() identifier
  @Input() globalData
  @Input() componentData
  startDate: Date
  endDate: Date

  constructor(
    public localDeviceDetector: LocalDeviceDetectorService,
    private dateFormat: DateFormatService
  ) { }

  ngOnInit(): void {
    this.startDate = this.dateFormat.convertFromTimestampToDate(this.globalData?.date?.start)
    this.endDate = this.dateFormat.convertFromTimestampToDate(this.globalData?.date?.end)
  }

}
